var angular = require('angular'),
    services = require('../services/');

module.exports =
angular.module('agada.controllers', ['ui.bootstrap.modal', 'ui.bootstrap.carousel', 'ui.bootstrap.tpls', services])
    .controller("AppController",  ['$scope', '$rootScope', '$location', '$state', '$stateParams', '$modal', '$window', 'Stories', 'StoriesKids', function ($scope, $rootScope, $location, $state, $stateParams, $modal, $window, Stories, StoriesKids) {
        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
            $rootScope.isTouch = true;
        }

        $rootScope.openStoryKids = function (nid, type) {
            if (!$rootScope.isMobile && !$(".fullKidsDiv").length > 0) {
                if ($state.$current.self.name != 'agadaKids') { 
					$rootScope.state = angular.copy($state.$current.self.name);
					$rootScope.params = angular.copy($stateParams);
					$rootScope.oldTitle = $window.document.title;
				}
                $state.go('agadaKids', { agadaId: nid }, { notify: false });
                StoriesKids.getStory(nid).then(function (result) {
					if (!result) {
						$location.path('/kids/404.html');
						$location.replace();
						return;
					}
                    $modal.open({
                        template: require("../../kids/views/story.html"),
                        controller: "storyCtl",
                        resolve: {
                            result: function () {
                                return result;
                            },
                            locationParamsAndHash: function () {
                                return {
                                    state: $rootScope.state,
                                    params: $rootScope.params,
									oldTitle: $rootScope.oldTitle,
                                };
                            }
                        }
                    })
                })
            }
            else {
                $state.go('agadaKids', { agadaId: nid });
            }

        }


        $rootScope.openStoryAdults = function (nid, type) {
            if (!$rootScope.isMobile && !$(".fullDiv").length > 0) {
                if ($state.$current.self.name != 'agada') { 
					$rootScope.state = angular.copy($state.$current.self.name);
					$rootScope.params = angular.copy($stateParams);
					$rootScope.oldTitle = $window.document.title;
				}
                $state.go('agada', { agadaId: nid }, { notify: false });
                Stories.getStory(nid).then(function (result) {
					if (!result) {
						$location.path('/404.html');
						$location.replace();
						return;
					}
                    $modal.open({
                        template: require("../../views/modals/story.html"),
                        controller: "storyCtl",
                        resolve: {
                            result: function () {
                                return result;
                            },
                            locationParamsAndHash: function () {
                                return {
                                    state: $rootScope.state,
                                    params: $rootScope.params,
									oldTitle: $rootScope.oldTitle,
                                };
                            }
                        }
                    })
                })
            }
            else {
                $state.go('agada', { agadaId: nid });
            }

        }
    }])
    .controller("storyCtl", ['$scope', '$modalInstance', '$state', '$window', '$location', '$rootScope', 'result', 'locationParamsAndHash', 'PICTURE_PATH', 'PRESENTATION_PATH', function ($scope, $modalInstance, $state, $window, $location, $rootScope, result, locationParamsAndHash, PICTURE_PATH, PRESENTATION_PATH) {
		//this controller is for pop up stories in adult and kids together
        $scope.stateName = locationParamsAndHash.state;
        $scope.stateParams = locationParamsAndHash.params;
        $scope.PRESENTATION_PATH = PRESENTATION_PATH;
        $scope.PICTURE_PATH = PICTURE_PATH;
        var body = angular.element(document).find('body')[0];
        body.style.overflow = "hidden"
        $scope.obj = result;  
		
		console.log($state.$current.name);
		if ($state.$current.name.localeCompare("agadaKids") == 0)
			$window.document.title = 'אתר ספר האגדה לילדים - '+$scope.obj.title;
		else if ($state.$current.name.localeCompare("agada") == 0)
			$window.document.title = 'אתר האגדה - '+$scope.obj.title;
        $rootScope.show = { showOther: '' };
        $scope.active = 0;

        $scope.url = $location.absUrl();
        $(document).ready(function () {
            $('code[title]').tooltip({ placement: 'bottom' });
            $scope.wholeTextHeight = $('.storyText')[0].scrollHeight;
            $scope.textContinuation = $('.storyText')[0].scrollHeight > $('.storyText')[0].clientHeight
            if ($('.storyExplanationText') && $('.storyExplanationText')[0]) {
                $scope.wholeExpHeight = $('.storyExplanationText')[0].scrollHeight;
                $scope.explanationContinuation = $('.storyExplanationText')[0].scrollHeight > $('.storyExplanationText')[0].clientHeight
                if (!$scope.$$phase) $scope.$apply()
            }
        });

        $scope.openInKids = function (story) {
            $window.open('/kids/node/' + story.kids_nid, '_blank');
        }

        $scope.openInAdults = function (story) {
            $window.open('/node/' + story.adults_nid, '_blank');
        }

        $scope.showEndStory = false;
        $scope.showEndExplanation = false;
        $scope.showOptions = false;

        $scope.cancel = function () { $modalInstance.close(true); };
        $scope.cancel2 = function () { $modalInstance.close(false); };

        $modalInstance.result.then(function (result) {
            if (result) {//when closing definitely
                body.style.overflow = "scroll";
                $state.go($scope.stateName, $scope.stateParams, { notify: false });
				$window.document.title = $rootScope.oldTitle;
            }
        }, function (result) {//when opening a related story 
            if (result) {
                body.style.overflow = "scroll";
                $state.go($scope.stateName, $scope.stateParams, { notify: false });
				$window.document.title = $rootScope.oldTitle;
            }
        })
    }])
    .controller("mainPageCtl", ['$rootScope', '$scope', '$http', '$location', '$window', 'Subjects', 'Stories', 'AdvSearch', 'PICTURE_PATH', function ($rootScope, $scope, $http, $location, $window, Subjects, Stories, AdvSearch, PICTURE_PATH) {
        $window.document.title = 'אתר האגדה - אוצר אגדות חז"ל ברשת';
        $scope.links = "";
        $scope.Stories = Stories;
        $scope.PICTURE_PATH = PICTURE_PATH;
        var random;
        var lastRandom = -1;;
        var arrayLocationIndex;

        var colors = ["#DEA327", "#59B3C6", "#0E4661", "#927389"];
        //getting stories
        $scope.arrAll = "";
        $scope.stories = Stories.getStories();
        $scope.arrAll = $scope.stories;
        AdvSearch.textToSearch = ''

        $scope.init = function () {
            //getting subjects
            $scope.subjects = Subjects.getSubjects();
            $scope.subjects.forEach(function (subject, index) {
                subject.color = colors[index % colors.length];
            });
            if (!$rootScope.subjectLoaded) {
                $rootScope.markReverseStoriesIndex = 0;
                $rootScope.arrayLocationIndex = 0;
                $rootScope.subjectLoaded = true;
                addSubjects($scope.subjects);
            }

        }

        var addSubjects = function (subjects) {
            random = Math.floor((Math.random() * 5) + 0);
            for ($rootScope.arrayLocationIndex = 0, $rootScope.index = 0; $rootScope.arrayLocationIndex + random <= $scope.arrAll.length; $rootScope.index++, $rootScope.arrayLocationIndex += 5) {
                $scope.arrAll.splice($rootScope.arrayLocationIndex + random, 0, $rootScope.index);
                lastRandom = random;
                do {
                    random = Math.floor((Math.random() * 5) + 0);
                } while (random == lastRandom);
            };
            markReverseStories($scope.arrAll);


        };

        var markReverseStories = function (array) {
            var randomReverseStory;
            for (; $rootScope.markReverseStoriesIndex + 5 < array.length; $rootScope.markReverseStoriesIndex += 5) {
                do {
                    randomReverseStory = Math.floor((Math.random() * 5) + 0);
                } while (!isNaN(array[$rootScope.markReverseStoriesIndex + randomReverseStory]));

                array[$rootScope.markReverseStoriesIndex + randomReverseStory].reverse = true;
            }
        }


        $scope.getMore = new Object();
        $scope.getMore.loadMore = true;
        $scope.addStories = function () {
            return Stories.queryAddStories($rootScope.callNumber, $scope.getMore).then(function (result) {
                if (result) {
                    $rootScope.callNumber++;
                    $scope.arrAll = Stories.getStories();
                    random = Math.floor((Math.random() * 5) + 0);
                    for (; $rootScope.arrayLocationIndex + random <= $scope.arrAll.length; $rootScope.index++, $rootScope.arrayLocationIndex += 5) {
                        $scope.arrAll.splice($rootScope.arrayLocationIndex + random, 0, $rootScope.index);
                        lastRandom = random;
                        do {
                            random = Math.floor((Math.random() * 5) + 0);
                        } while (random == lastRandom);
                    };
                    $scope.getMore.loadMore = true;
                    markReverseStories($scope.arrAll);
                    return ($scope.arrAll);
                }
            });
        };

    }])
    .controller("mainPageKidsCtl", ['$scope', '$rootScope', '$modal', '$state', '$location', '$window', '$anchorScroll', 'SubjectsKids', 'StoriesKids', 'AdvSearch', 'PICTURE_PATH', function ($scope, $rootScope, $modal, $state, $location, $window, $anchorScroll, SubjectsKids, StoriesKids, AdvSearch, PICTURE_PATH) {
        $window.document.title = 'אתר האגדה - אתר האגדה לילדים';
        $scope.PICTURE_PATH = PICTURE_PATH;
        $scope.subjects = SubjectsKids.getSubjects();
        $scope.SubjectsKids = SubjectsKids;
        $scope.StoriesKids = StoriesKids;
        $scope.stories = StoriesKids.getStories();
        AdvSearch.textToSearch = '';
        $scope.getSubjectName = function (tid) {
            for (var i = 0; i < $scope.subjects.length; i++) {
                if ($scope.subjects[i].tid.toString() == tid.toString()) {
                    return $scope.subjects[i].name;
                }
            }
        }

        
        $scope.page = 1
        $scope.getMore = new Object();
        $scope.getMore.loadMore = true;
        $scope.addStories = function () {
            StoriesKids.queryAddStories($scope.page, $scope.getMore).then(function (result) {
                if (result) {
                    // console.log(result);
                    $scope.page++;
                    $scope.stories = result;
                    $scope.getMore.loadMore = true;
                }
            });
        }

        $rootScope.$on('allstories', function (ev, data) {
            $scope.stories = data;
            $scope.getMore.loadMore = false;
        });

        $scope.setDisplaying = function (disp) {
            if (!$rootScope.finishLoadST) {
                StoriesKids.queryAllStories().then(function (result) {
                    $scope.stories = result;
                    $scope.getMore.loadMore = false;
                })
            } 
            StoriesKids.setDisplaying(disp);
        }
        
    }])
    .controller("menuKidsCtl", ['$scope', '$rootScope', '$location', '$state', '$anchorScroll','$window', 'SubjectsKids', 'StoriesKids', 'AdvSearch', function ($scope, $rootScope, $location, $state, $anchorScroll,$window, SubjectsKids, StoriesKids, AdvSearch) {
        $scope.$state = $state;
        $scope.showSidebarMobile = false
        $scope.showSearchMobile = false
        $scope.subjects = SubjectsKids.getSubjects();
        $scope.SubjectsKids = SubjectsKids;
        $scope.StoriesKids = StoriesKids;
        $scope.AdvSearch = AdvSearch;
		
		if ($state.$current.name.localeCompare("advancedSearchKids") == 0)
			$window.document.title = 'אתר האגדה לילדים - חיפוש מתקדם';
		else if ($state.$current.name.localeCompare("otherwiseKids") == 0)
			$window.document.title = "אתר ספר האגדה לילדים - דף 404";

        $scope.searchText = function (textToSearch) {
			if (!textToSearch || !textToSearch.replace(/\s/g,'')) // if search is empty we don't want to continue
				return;
			
            $scope.showSearchMobile = false
            $scope.searches = AdvSearch.getAdvSearchData();
            var path = '/kids/';
            angular.forEach($scope.searches, function (s) {
                path += s.param + '/0/';
            })
            path += 'kids/' + 1 + '/adults/' + 0 + '/freeText/' + textToSearch;
            $location.path(path)
        }

        $scope.showSidebar = function (s) {
            $scope.showSidebarMobile = s;
        }
        $scope.showSearch = function (s) {
            $scope.showSearchMobile = s;
        }

        $scope.setDisplaying = function (disp) {
            if (!$rootScope.finishLoadST) {
                StoriesKids.queryAllStories().then(function (result) {
                    $rootScope.$broadcast('allstories', result);
                })
            }
            StoriesKids.setDisplaying(disp);
        }

        $scope.subjectClick = function (subject) {
            if (!$rootScope.finishLoadST) {
                StoriesKids.queryAllStories().then(function (result) {
                    $rootScope.$broadcast('allstories', result);
                    filter();
                })
            } 
            else {
                filter();
            }

            function filter() {
                if ($location.path() != '/kids') {
                    $location.path('/kids')
                }
                SubjectsKids.setChosenSubject(subject);
                $scope.hoverSidebar = false;//to do !!!!!!!!!!
                $scope.showSidebarMobile = false;//to do !!!!!!!!!
                $anchorScroll()
            }
        }

        $scope.subjectTouch = function (subject) {
            $scope.openSideBar = !$scope.openSideBar;
            if (!$scope.openSideBar) { $scope.subjectClick(subject) }
        }


        var body = angular.element(document).find('body')[0];
        $scope.$watch("showSidebarMobile", function (newValue, oldValue) {
            if (newValue) {
                angular.element('#sidebarMobile').css('overflow-y', 'visible');
                body.style.overflow = "hidden";
            } else {
                angular.element('#sidebarMobile').css('overflow-y', 'hidden');
                body.style.overflow = "visible";
            }
        });


        $rootScope.$watch('isMobile', function (newValue, oldValue) {
            if (newValue && $scope.showSidebarMobile)
                body.style.overflow = "hidden";
            else
                body.style.overflow = "visible";
        });
    }])
    .controller("agadaKidsCtl", ['$scope', '$http', '$stateParams', '$window', '$anchorScroll','$state','$location' ,'StoriesKids', 'PICTURE_PATH', 'PRESENTATION_PATH', function ($scope, $http, $stateParams, $window, $anchorScroll,$state ,$location, StoriesKids, PICTURE_PATH, PRESENTATION_PATH) {
        $scope.show = {};
        $scope.$anchorScroll = $anchorScroll;
        $scope.PRESENTATION_PATH = PRESENTATION_PATH;
        $scope.PICTURE_PATH = PICTURE_PATH;
        if ($stateParams.agadaId) {
            var nid = $stateParams.agadaId
        }
        StoriesKids.getStory(nid).then(function (result) {
			if (!result) {
				$location.path('/kids/404.html');
				$window.document.title = "אתר ספר האגדה לילדים - דף 404";
				$location.replace();
				return;
			}
            $scope.obj = result;
			$window.document.title = "אתר ספר האגדה לילדים - "+$scope.obj.title;	
			
            $(document).ready(function () {
                $('code[title]').tooltip({ placement: 'bottom' });
                // close on body click 
                // iOS doesnt recognise 'body' click so using :not 
                $(':not(#anything)').on('click', function (e) {
                    $('code[title]').each(function () {
                        if (!$(this).is(e.target) && $(this).has(e.target).length === 0 && $('.tooltip').has(e.target).length === 0)
                        { $(this).tooltip('hide'); }
                    });
                });
               $scope.wholeTextHeight = $('.storyText')[0].scrollHeight;
               $scope.textContinuation = $('.storyText')[0].scrollHeight > $('.storyText')[0].clientHeight
               if ($('.storyExplanationText') && $('.storyExplanationText')[0]) {
                   $scope.wholeExpHeight = $('.storyExplanationText')[0].scrollHeight;
                   $scope.explanationContinuation = $('.storyExplanationText')[0].scrollHeight > $('.storyExplanationText')[0].clientHeight
               }
               if (!$scope.$$phase) $scope.$apply()
            });

            $scope.openInKids = function (story) {
                $window.open('/kids/node/' + story.kids_nid, '_blank');
            }

            $scope.openInAdults = function (story) {
                $window.open('/node/' + story.adults_nid, '_blank');
            }

            $scope.showEndStory = false;
            $scope.showEndExplanation = false;
            $scope.cancel = function () { $modalInstance.close(true); };
            $scope.active = 0;
        });
    }])
    .controller("agadaCtl", ['$scope', '$http', '$stateParams', '$window', '$location', '$anchorScroll', '$state' ,'Stories', 'PICTURE_PATH', function ($scope, $http, $stateParams, $window, $location, $anchorScroll,$state, Stories, PICTURE_PATH) {
	
        $scope.$anchorScroll = $anchorScroll;
        $scope.show = {};
        $scope.PICTURE_PATH = PICTURE_PATH;
        $scope.url = $location.absUrl();
        if ($stateParams.agadaId) {
            var nid = $stateParams.agadaId
        }
        Stories.getStory(nid).then(function (result) {
			if (!result) {
				$location.path('/404.html');
				$window.document.title = "אתר ספר האגדה - דף 404";
				$location.replace();
				return;
			}
				
            $scope.obj = result;
			
			$window.document.title = "אתר האגדה - "+$scope.obj.title;
			
            $(document).ready(function () {
                $('code[title]').tooltip({ placement: 'bottom' });
                // close on body click 
                // iOS doesnt recognise 'body' click so using :not 
                $(':not(#anything)').on('click', function (e) {
                    $('code[title]').each(function () {
                        if (!$(this).is(e.target) && $(this).has(e.target).length === 0 && $('.tooltip').has(e.target).length === 0)
                        { $(this).tooltip('hide'); }
                    });
                });
                $scope.wholeTextHeight = $('.storyText')[0].scrollHeight;
                $scope.textContinuation = $('.storyText')[0].scrollHeight > $('.storyText')[0].clientHeight
                if ($('.storyExplanationText') && $('.storyExplanationText')[0]) {
                    $scope.wholeExpHeight = $('.storyExplanationText')[0].scrollHeight;
                    $scope.explanationContinuation = $('.storyExplanationText')[0].scrollHeight > $('.storyExplanationText')[0].clientHeight
                }
                if (!$scope.$$phase) $scope.$apply()
            });

            $scope.openInKids = function (story) {
                $window.open('/kids/node/' + story.kids_nid, '_blank');
            }

            $scope.openInAdults = function (story) {
                $window.open('/node/' + story.adults_nid, '_blank');
            }

            $scope.showEndStory = false;
            $scope.showEndExplanation = false;
            $scope.showOptions = false;

            $scope.cancel = function () { $modalInstance.close(true); };

        });
    }])
    .controller("advancedSearchCtl", ['$rootScope', '$scope', '$http', '$location', '$stateParams', '$window', 'AdvSearch', 'Stories', function ($rootScope, $scope, $http, $location, $stateParams,$window, AdvSearch, Stories) {
		// $window.document.title = "אתר האגדה - חיפוש מתקדם";
        $scope.Stories = Stories;
        $scope.AdvSearch = AdvSearch;
        $scope.searches = AdvSearch.getAdvSearchData();
        angular.forEach($scope.searches, function (s) {
            s.search = '0';
        });

        $scope.kidSite = '0';
        $scope.adultSite = '0';
        var path = $location.path();
        var params = path.split("/");
        (params[1] == 'kids') ? $scope.kidSite = '1' : $scope.adultSite = '1';


        $scope.search = function () {
            var path;
            ($location.path().indexOf('kids') > -1) ? path = '/kids/' : path = '/';
            angular.forEach($scope.searches, function (s) {
                path += s.param + '/' + s.search + '/';
            })
            path += 'kids/' + $scope.kidSite + '/adults/' + $scope.adultSite + '/freeText/';
            $location.path(path)
        }
    }])
    .controller("searchResultsCtl", ['$rootScope', '$scope', '$http', '$location', '$stateParams', '$window', 'Stories', 'AdvSearch', 'PICTURE_PATH', 'AJAX_DOMAIN_PATH', function ($rootScope, $scope, $http, $location, $stateParams, $window, Stories, AdvSearch, PICTURE_PATH, AJAX_DOMAIN_PATH) {
       
		$scope.Stories = Stories;
        $scope.PICTURE_PATH = PICTURE_PATH;
        $scope.$stateParams = $stateParams;
		$window.document.title = ' אתר האגדה - תוצאות חיפוש : ' + $scope.$stateParams.freeText;
        $scope.getMore = {};
        $scope.getMore.loadMore = true;
        $scope.page = 0;
        $scope.currSearch = []
        findSearchTerms();
        function findSearchTerms() {
            var searches = AdvSearch.getAdvSearchData();
            angular.forEach($stateParams, function (param, prop) {
                if (param != '0' && param != null) {
                    for (var i = 0; i < searches.length; i++) {
                        if (searches[i].param == prop) {
                            for (var j = 0; j < searches[i].list.length; j++) {
                                if (searches[i].list[j].tid.toString() == param.toString()) {
                                    $scope.currSearch.push({ name: searches[i].list[j].name });
                                }
                            }

                        }
                        //break;//break for loop
                    }
                }
            })
        }
        var path = $location.path();
        var params = path.split("/");
        if (params[1] == 'kids') { $scope.kids = true }
        $scope.getResults = function () {
            if ($stateParams.freeText) {
                $http.get(AJAX_DOMAIN_PATH + '/api/search/textual_search_api/stories?keys=' + encodeURI($stateParams.freeText) + '&kids=' + parseInt($stateParams.kids).toString() + '&limit=10&offset=0').then(function (response) {
                    if (response) {
                        $scope.results = $.map(response.data.result, function (value, index) {
                            return [value];
                        });
                        $scope.count = response.data.count;
                    }
                });
            }
            else {
                var data = { "term_tid": parseInt($stateParams.term_tid).toString(), "person": parseInt($stateParams.person).toString(), "parasha": parseInt($stateParams.parasha).toString(), "time_of_year": parseInt($stateParams.time_of_year).toString(), "mikra_book": parseInt($stateParams.mikra_book).toString(), "midrash_source": parseInt($stateParams.midrash_source).toString(), "writer": parseInt($stateParams.writer).toString(), "kids_writer": parseInt($stateParams.kids_writer).toString(), "kids": parseInt($stateParams.kids).toString(), "adults": parseInt($stateParams.adults).toString() };
                $http.post(AJAX_DOMAIN_PATH + '/api/advanced_search/advanced_search/getResults?page=0&pagesize=10', JSON.stringify(data)).then(function (response) {
                    if (response) {
                        $scope.results = angular.copy(response.data.results);
                        $scope.count = response.data.count;
                    }
                });
            }
        }

        $scope.addResults = function () {
            if ($stateParams.freeText) {
                $scope.page++;
                $http.get(AJAX_DOMAIN_PATH + '/api/search/textual_search_api/stories?keys=' + encodeURI($stateParams.freeText) + '&kids=' + parseInt($stateParams.kids).toString() + '&limit=10&offset=' + $scope.page * 10).then(function (response) {
                    if (response) {
                        if (response.data && !jQuery.isEmptyObject(response.data.result)) {
                            var tempResult = $.map(response.data.result, function (value, index) {
                                return [value];
                            });
                            $scope.results = $scope.results.concat(tempResult);
                            $scope.getMore.loadMore = true;
                        }
                        else {
                            $scope.getMore.loadMore = false;
                        }
                    }
                });
            }
            else {
                $scope.page++;
                var data = { "term_tid": parseInt($stateParams.term_tid).toString(), "person": parseInt($stateParams.person).toString(), "parasha": parseInt($stateParams.parasha).toString(), "time_of_year": parseInt($stateParams.time_of_year).toString(), "mikra_book": parseInt($stateParams.mikra_book).toString(), "midrash_source": parseInt($stateParams.midrash_source).toString(), "writer": parseInt($stateParams.writer).toString(), "kids_writer": parseInt($stateParams.kids_writer).toString(), "kids": parseInt($stateParams.kids).toString(), "adults": parseInt($stateParams.adults).toString() };
                $http.post(AJAX_DOMAIN_PATH + '/api/advanced_search/advanced_search/getResults?page=' + $scope.page + '&pagesize=10', JSON.stringify(data)).then(function (response) {
                    if (response) {
                        if (response.data && response.data.results.length > 0) {
                            $scope.results = $scope.results.concat(response.data.results);
                            $scope.getMore.loadMore = true;
                        }
                        else {
                            $scope.getMore.loadMore = false;
                        }
                    }
                });
            }
        }

        $scope.open = function (story) {
            if ($scope.kids == true) {//we are in kid's site
                (story.type == 'agada_children_story') ? $rootScope.openStoryKids(story.nid, story.type) : $window.open( '/node/' + story.nid, '_blank');;
            }
            else { //we are in adult's site
                (story.type == 'agada_story') ? $rootScope.openStoryAdults(story.nid, story.type) : $window.open('/kids/node/' + story.nid, '_blank');;
            }
        }
    }])
    .controller("menuCtl", ['$rootScope', '$scope', '$location', '$timeout', '$state', '$window', 'Subjects', 'AdvSearch', '$anchorScroll', 'MOBILE_STATE', 'TABLET_STATE', 'NORMAL_STATE', 'PICTURE_PATH', function ($rootScope, $scope, $location, $timeout, $state, $window,Subjects, AdvSearch, $anchorScroll, MOBILE_STATE, TABLET_STATE, NORMAL_STATE, PICTURE_PATH) {
        $scope.initialization = function () {
            $scope.menuShow = false;
            $scope.currSubject;
            $scope.showSidebarMobile = false;
            $scope.$state = $state;
            $scope.showSearchMobile = false;
			
        }
		// console.log($state.$current.name);
		if ($state.$current.name.localeCompare("about") == 0)
			$window.document.title = 'אתר האגדה - אודות';
		else if ($state.$current.name.localeCompare("map") == 0)
			$window.document.title = 'אתר האגדה - מפה';
		else if ($state.$current.name.localeCompare("advancedSearch") == 0)
			$window.document.title = 'אתר האגדה - חיפוש מתקדם';
		else if ($state.$current.name.localeCompare("otherwise") == 0)
			$window.document.title = "אתר ספר האגדה - דף 404";
		
        $rootScope.$watch('isMobile', function (newValue, oldValue) {
            if (newValue)
                if ($scope.menuShow)
                    $scope.showSidebar(true);
                else
                    $scope.showSidebar(false);
            else
                if ($scope.showSidebarMobile)
                    $scope.openMenu();
                else
                    $scope.hideMenu();

        });
        var body = angular.element(document).find('body')[0];
        $scope.$watch("showSidebarMobile", function (newValue, oldValue) {
            if (newValue) {
                angular.element('#side-menu').css('overflow-y', 'visible');
                body.style.overflow = "hidden";
            } else {
                angular.element('#side-menu').css('overflow-y', 'hidden');
                body.style.overflow = "visible";
            }
        });

        $scope.moveToKidsLink = function () {
            $scope.hideMenu();
            $scope.showSidebar(false);
            $location.path('/kids');
        }


        $scope.showSidebar = function (s) {
            $scope.showSidebarMobile = s;
            if (!$scope.showSidebarMobile) {
                $scope.currSubject = false;
            }
        }

        $scope.showSearch = function (s) {
            $scope.showSearchMobile = s;
        }

        $scope.AdvSearch = AdvSearch;
        var mouseOverSubjectIndex = 0;
        $scope.loadingIndex = 1;
        $scope.scrollPassedHeader = { 'visiable': false };

        $scope.openSearchSticky = false;

        $scope.searchText = function (textToSearch) {
            $scope.showSearchMobile = false;
            $scope.searches = AdvSearch.getAdvSearchData();
            var path = '/';
            angular.forEach($scope.searches, function (s) {
                path += s.param + '/0/';
            })
            path += 'kids/' + 0 + '/adults/' + 0 + '/freeText/' + textToSearch;
            $location.path(path);
        }


        Subjects.getPromise().then(function (subjects) {
            $scope.PICTURE_PATH = PICTURE_PATH;
            $scope.subjects = subjects;
            $scope.subs = $scope.subjects[mouseOverSubjectIndex];
            $scope.openSubSubject = function (index) {

                if (mouseOverSubjectIndex != index) {
                    mouseOverSubjectIndex = index;
                    $scope.subs = $scope.subjects[mouseOverSubjectIndex];
                    $scope.subs.show_arrow = "arrowShown";
                }
            };
        });


        $scope.iconPressStickySearch = function () {
            $scope.openSearchSticky = !$scope.openSearchSticky;
            angular.element('#stickySearchInput').focus();

        }
        $scope.upperMenuReady = function () {
        }

        $scope.showSubSubject = function (subject) {
			// console.log(subject);
            $scope.currSubject = subject;
        }


        $rootScope.subjectClick = function (tid, from_menu) {
            if (!from_menu) {
                $scope.hideMenu();
                $location.path('subject/' + tid);
                return;
            }


            if ($rootScope.screenState == NORMAL_STATE) {
                $scope.hideMenu();
                $location.path('subject/' + tid);
            }
            else if ($rootScope.screenState == MOBILE_STATE) {

            }
        }

        $rootScope.subSubjectClick = function (tid, subTid, index) {
            var linkData = { 'tid': tid, 'subTid': subTid, 'index': index };
            $scope.hideMenu();
            $location.path('subject/' + tid);
            $location.hash(subTid);

            $rootScope.$broadcast('subject:menuSubSubjetPress', linkData);
            $scope.showSidebar(false);
        }

        $scope.menuShow = false;
        $scope.displayMenu = function () {
            $scope.menuShow = !$scope.menuShow;
            if ($scope.menuShow) {
                body.style.overflow = "hidden";
            }
            else {
                body.style.overflow = "";
            }
        };
        $scope.openMenu = function () {
            if ($scope.menuShow) // unless is map
                body.style.overflow = "";
            $scope.menuShow = true;
        };

        $scope.hideMenu = function () {
            if ($scope.menuShow) // unless is map
                body.style.overflow = "visible";
            $scope.menuShow = false;
        };

        $scope.showSidebar(false);
        $scope.hideMenu();
        $rootScope.$on('$routeChangeSuccess', function (event, newRoute, oldRoute) {
            $scope.menuShow = false;
            $anchorScroll();
        });
		
		$rootScope.$on('subject:mobileSubjectPage', function (ev, subjectTid) {
			// console.log(subjectTid);
			$scope.showSidebar(true);
			// console.log($scope.subjects);
			$scope.subjects.forEach(function (subject){
				if (subject.tid == subjectTid.tid){
					// console.log(subject);
					$scope.showSubSubject(subject);
					return;
				}
			});
			// showSubSubject(subjectId.id);
		});

    }])
    .controller("subjectCtl", ['$rootScope', '$scope', '$location', '$stateParams', '$window', 'SubjectData', '$anchorScroll', 'Subjects', 'Stories', 'PICTURE_PATH', function ($rootScope, $scope, $location, $stateParams,$window, SubjectData, $anchorScroll, Subjects, Stories, PICTURE_PATH) {
		// $window.document.title = "אתר האגדה - דף נושא";
        $scope.Stories = Stories;
        $scope.subSubjects = "";
        $scope.subjectname = "";
        $scope.numOfStories = 0;
        var colors = ["#DEA327", "#59B3C6", "#0E4661", "#927389"];
        var colorMove = 0;
        var lastSubjectIndex = 0;
        $scope.m = false
        $scope.PICTURE_PATH = PICTURE_PATH;
	
        $scope.changeSubSubject = function (i) {
            if ($scope.subSubjects) {
                var subSubject = $scope.subSubjects[i];
                subSubject.opened = !subSubject.opened;
                if (subSubject.opened) {
                    subSubject.amount = subSubject.nodes.length;
                    subSubject.minimizeMassage = "צמצם";
                }
                else {
                    subSubject.amount = 5;
                    subSubject.minimizeMassage = "הצג הכל";
                }
            }
        };

        $scope.$on('subject:menuSubSubjetPress', function (ev, data) {
            if (!$rootScope.isMobile)
                $scope.scrollToSubSucject(data.subTid, data.index);
            mobileGoToSubSubject();
        });

        var mobileGoToSubSubject = function () {
            if ($rootScope.isMobile) {
                var tid = $location.hash();
				if (tid){
					$scope.subSubjects.forEach(function (subSubject) {
						if (subSubject.tid == tid) {
							$scope.subSubjectData = subSubject;
							// console.log($scope.subSubjectData.name);
							$window.document.title = $scope.subjectname +" - "+$scope.subSubjectData.name;
							return;
						}
					});
				}
            }
        }
		$rootScope.$watch('isMobile', function (newValue, oldValue) {
			var tid = $location.hash();
			// console.log(1,tid);
			if (newValue && !tid) {
				// console.log(newValue,tid);
				var subjectTid = { 'tid': lastSubjectIndex};
				$rootScope.$broadcast('subject:mobileSubjectPage', subjectTid);
			}
		});
		
		$scope.$watch('subjectname', function (newValue, oldValue) {
			if (newValue) {
				// console.log(newValue);
				$window.document.title = $scope.subjectname;
			}
		});
		
        var markReverseStories = function (array) {

            var randomReverseStory = Math.floor((Math.random() * 5) + 0);

            for (var i = 0; i + randomReverseStory < array.length; i += 5) {
                array[i + randomReverseStory].reverse = true;
                randomReverseStory = Math.floor((Math.random() * 5) + 0);
            }
        }

        /*minimize all subject and open only one*/
        $scope.scrollToSubSucject = function (subTid, index) {
            $scope.subSubjects.forEach(function (subSubject) {
                subSubject.amount = 5;
                subSubject.minimizeMassage = "הצג הכל";
                subSubject.opened = false;
            });
            $location.hash(subTid);
			$anchorScroll.yOffset = 80;
            $anchorScroll();
            var subSubject = $scope.subSubjects[index];
            subSubject.amount = subSubject.nodes.length;
            subSubject.minimizeMassage = "צמצם";
            subSubject.opened = true;
        };
        if ($stateParams.subjectId && lastSubjectIndex != $stateParams.subjectId) {
            Subjects.getPromise().then(function (subjects) {
				var isChanged = false;
                subjects.forEach(function (subject) {
                    if (subject.tid == $stateParams.subjectId){
						isChanged = true;
						$scope.subjectname = subject.name;
					}
                });
				if (isChanged)
					lastSubjectIndex = $stateParams.subjectId;
				else{ // if no subject with this id selected we go to 404
					$location.path('/404.html');
					$window.document.title = "אתר ספר האגדה - דף 404";
					$location.replace();
					return;
				}
            });
            SubjectData.query($stateParams.subjectId).then(function (response) {
                $scope.subSubjects = response;
                $scope.subSubjects.forEach(function (subSubject) {


                    subSubject.nodes.sort2values(function (story) {
                        if (story.filename)
							return true;
                    });
                    markReverseStories(subSubject.nodes);
                    subSubject.nodes.forEach(function (node, index) {
                        node.color = colors[(colorMove + index) % colors.length];
                    });
                    colorMove++;
                    $scope.numOfStories += subSubject.nodes.length;
                    subSubject.minimizeMassage = "הצג הכל";
                    subSubject.opened = false;
                    subSubject.amount = 5;

                });

                mobileGoToSubSubject();
            },
            function subjectLoadError(response) {
                console.log("error getting subject");
            });

        }
		



        $scope.goToSubSubject = function () {
            var tid = $location.hash();
            $scope.subSubjects.forEach(function (subSubject) {
                if (subSubject.tid == tid) {
                    $scope.subSubjectArray = subSubject;
                    subSubject.amount = subSubject.nodes.length;
                    subSubject.minimizeMassage = "צמצם";
                    subSubject.opened = true;
                    setTimeout(function () {
                        $anchorScroll.yOffset = 80;
                        $anchorScroll();

                    }, 0);
                }
                else {
                    subSubject.amount = 5;
                    subSubject.minimizeMassage = "הצג הכל";
                }
            });
        };
    }])
    .controller('mapCtl', require('./mapCtl.js'))
    .name;


//////////////////
// WEBPACK FOOTER
// ./public/js/controllers/controllers.js
// module id = 86
// module chunks = 0